export default __webpack_public_path__ + "static/media/parking.507e90d5.svg";